import { render, staticRenderFns } from "./DashboardNewsPreviewModal.vue?vue&type=template&id=66c62979&scoped=true"
import script from "./DashboardNewsPreviewModal.vue?vue&type=script&lang=js"
export * from "./DashboardNewsPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardNewsPreviewModal.vue?vue&type=style&index=0&id=66c62979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c62979",
  null
  
)

export default component.exports